import {createI18n} from 'vue-i18n';
import { i18n } from '@/main.js';
import {useTermsStore} from '@/stores/TermsStore';
import {reactive} from "vue";

const messages = {
    'dashboard': {
        'de-DE': require('./dashboard/de-DE.json'),
        'en-US': require('./dashboard/en-US.json'),
        'es-ES': require('./dashboard/es-ES.json'),
        'eu-EU': require('./dashboard/eu-EU.json'),
        'fr-FR': require('./dashboard/fr-FR.json'),
        'he-IL': require('./dashboard/he-IL.json'),
        'it-IT': require('./dashboard/it-IT.json'),
        'tl-PH': require('./dashboard/tl-PH.json'),
        'zh-CHT': require('./dashboard/zh-CHT.json'),
        'zh-HK': require('./dashboard/zh-HK.json'),
        'nl-NL': require('./dashboard/nl-NL.json'),
    },
    'map': {
        'ar-JO': require('./map/ar-JO.json'),
        'de-DE': require('./map/de-DE.json'),
        'en-US': require('./map/en-US.json'),
        'es-ES': require('./map/es-ES.json'),
        'eu-EU': require('./map/eu-EU.json'),
        'fr-FR': require('./map/fr-FR.json'),
        'he-IL': require('./map/he-IL.json'),
        'it-IT': require('./map/it-IT.json'),
        'ja-JP': require('./map/ja-JP.json'),
        'ko-KO': require('./map/ko-KO.json'),
        'nl-NL': require('./map/nl-NL.json'),
        'no-NO': require('./map/no-NO.json'),
        'pt-BR': require('./map/pt-BR.json'),
        'pt-PT': require('./map/pt-PT.json'),
        'ro-RO': require('./map/ro-RO.json'),
        'ru-RU': require('./map/ru-RU.json'),
        'sl-SI': require('./map/sl-SI.json'),
        'sv-SE': require('./map/sv-SE.json'),
        'zh-CHT': require('./map/zh-CHT.json'),
        'zh-CN': require('./map/zh-CN.json'),
        'tl-PH': require('./map/tl-PH.json'),
        'zh-HK': require('./map/zh-HK.json'),
    }
};

const createAppI18n = (scope) => {
    const options = {
        legacy: false,
        messages: messages[scope]
    };

    return createI18n(options);
};

//wrapper for translation function
const tt = (...args) => {
    const { t } = i18n.global;
    const locale = i18n.global.locale;

    //get the translation
    let value = t(...args);

    //check for terminology, only for english
    if (locale.value == 'en-US') {
        const termsStore = useTermsStore();
        const state = reactive({
            getTermValueByKey: termsStore.getTermValueByKey
        });

        return state.getTermValueByKey(value);
    }

    //else return the translation
    return value.toUpperCase();
}

export {createAppI18n, tt};